import React, {useEffect, useState} from 'react';
import './GamesListContainer.scss';
import GameListItem from "./GameListItem/GameListItem";
import Utils from "../../utils/Utils";
import LanguagePanel from "../LanguagePanel/LanguagePanel";
import {useTranslation} from "react-i18next";

function GamesListContainer({availableGames}) {
  const {t} = useTranslation();

  const [activeTab, setActiveTab] = useState(0);
  const [showBetShopGames, setShowBetShopGames] = useState(true);

  useEffect(() => {
    checkTabs();
  }, [])

  const checkTabs = () => {
    const betShopGames = availableGames.filter(item => item.name.indexOf('BetShop') !== -1);

    if (betShopGames.length === 0) {
      setShowBetShopGames(false);
      setActiveTab(1)
    }
  }

  const getHeaderTabs = () => {
    const betShopClassName = activeTab === 0 ? 'tab active' : 'tab';
    const webClassName = activeTab === 1 ? 'tab active' : 'tab';

    return <div className="header-tabs">
      {
        showBetShopGames
          ? <div className={betShopClassName} onClick={() => setActiveTab(0)}>{t('bet shop')}</div>
          : null
      }
      <div className={webClassName} onClick={() => setActiveTab(1)}>{t('web')}</div>
    </div>
  }

  const getListItemsContainer = () => {
    let gamesList;

    if (activeTab === 0) {
      gamesList = availableGames.filter(item => item.name.indexOf('BetShop') !== -1);
    } else {
      gamesList = availableGames.filter(item => item.name.indexOf('BetShop') === -1);
    }

    return <div className="list-items-container">
      {
        gamesList.map((data, key) => {
          return <GameListItem data={data} key={key} name={Utils.GAME_NAMES[data['id']]}/>
        })
      }
    </div>
  }

  return <div className='games-list-container'>
    <div className='header'>
      {
        getHeaderTabs()
      }
      <b>{t('games rules')}</b>
      <LanguagePanel/>
    </div>
    <div className="sub-header">{t('select game type')}</div>
    {
      getListItemsContainer()
    }
  </div>
}

export default GamesListContainer;